import Picker from '../picker';
import Panel from '../panel/time-select';

export default {
  mixins: [Picker],

  name: 'ZkTimeSelect',

  created() {
    this.type = 'time-select';
    this.panel = Panel;
  }
};



// WEBPACK FOOTER //
// ./src/packages/date-picker/src/picker/time-select.js